module.exports = __webpack_public_path__ + "img/imageGalery5.7db3cc45.jpg";